import { inflect } from 'inflection'
import {
  differenceInCalendarDays,
  isValid,
  parseISO
} from '@sequencehq/utils/dates'

/**
 * Builds the primary text for "Invoice sent" watchtower list items, e.g.
 * "INV-001: Invoice is due in 3 days" / "INV-001: Invoice is due today" /
 * "INV-001: Invoice is 2 days overdue".
 *
 * Day differences are UTC calendar days, matching the dates passthrough default.
 * `today` is injectable for tests.
 */
export const getInvoiceDueText = ({
  invoiceNumber,
  dueDate,
  today = new Date()
}: {
  invoiceNumber?: string
  dueDate?: string
  today?: Date
}): string => {
  const displayInvoiceNumber = invoiceNumber ?? 'Invoice'
  const parsedDueDate = dueDate ? parseISO(dueDate) : undefined

  if (!parsedDueDate || !isValid(parsedDueDate)) {
    return displayInvoiceNumber
  }

  const daysUntilDue = differenceInCalendarDays(parsedDueDate, today)

  if (daysUntilDue > 0) {
    return `${displayInvoiceNumber}: Invoice is due in ${daysUntilDue} ${inflect('day', daysUntilDue)}`
  }

  if (daysUntilDue === 0) {
    return `${displayInvoiceNumber}: Invoice is due today`
  }

  const daysOverdue = Math.abs(daysUntilDue)
  return `${displayInvoiceNumber}: Invoice is ${daysOverdue} ${inflect('day', daysOverdue)} overdue`
}
